<template>
  <div class="mail-list-box">
    <div class="main-container">
      <h2 class="">メール定型文設定</h2>
      <div class="list-box">
        <div class="list-header-box">
          <div class="flex">
            <p class="list-item1"></p>
            <p class="list-item2">ステータス</p>
            <p class="list-item3">送信タイミング</p>
          </div>
        </div>

        <div class="list-contents-box">
          <div class="flex" v-for="(list, index) in lists" :key="index">
            <p class="list-item1 center"><a class="" @click="list_info(list)">設定</a></p>
            <p class="list-item2 center" :class="status_class(list.status)" >{{status_text(list.status)}}</p>
            <p class="list-item3">{{list.name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MailList',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      lists: [],
      listing_id: 1,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.data_get();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('mail_template_list_get.php');
    },
    data_get_cb (res) {
      this.listing_id = res.data.listings[0].id;
      this.lists = res.data.listings[0].mail_templates;
    },
    list_info (list) {
      this.$router.push({name: 'mail_edit', params: {list, listing_id: this.listing_id}});
    },
    status_text (value) {
      if (value === 2) {
        return '有効';
      }
      return '無効';
    },
    status_class (value) {
      if (value === 2) {
        return 'status-on';
      }
      return 'status-off';
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.mail-list-box {
  text-align: left;

  .main-container {
    .new-add {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px 8px 8px 8px;
      width: 100%;
      font-size: 16px;
      margin: 50px auto 20px auto;
      text-decoration: none;
      border-radius: 3px;
      width: 50%;
    }
    .list-box {
      overflow-y: auto;
      height: calc(100vh - 92px);
    }
    .list-header-box {
      position: sticky;
      top: 0;
      p {
        background: #fbfbfb;
        border-top: 1px solid #ceced2;
        border-left: 1px solid #ceced2;
        border-bottom: 1px solid #ceced2;
        padding: 10px;
        color: #24273b;

        text-align: center;
        box-sizing: border-box;
        height: 46px;
      }
      p:last-child {
        border-right: 1px solid #ceced2;
      }
    }
    .list-contents-box {

      p {
        background: #fbfbfb;
        border-bottom: 1px solid #ceced2;
        border-left: 1px solid #ceced2;
        padding: 8px;

        box-sizing: border-box;
        height: 40px;
      }
      p:last-child {
        border-right: 1px solid #ceced2;
      }
    }
    .list-item1 {
      min-width: 70px;
      max-width: 70px;
    }
    .list-item2 {
      min-width: 120px;
      max-width: 120px;
    }
    .list-item3 {
      min-width: 450px;
      flex: 1;
    }
    .status-on {
      color: #33aa55;
      font-weight: bold;
    }
    .status-off {
      color: #999999;
    }
  }
  @media (max-width: 767px) {
    .main-container {
      .list-header-box {
      }
    }
  }
}
</style>
